// Days-left/days-since computations for the DAYS column (§5.7).
export function daysFor(row, now = Date.now()) {
  const trial = row.trial_ends_at ? new Date(row.trial_ends_at).getTime() : null;
  const grace = row.grace_ends_at ? new Date(row.grace_ends_at).getTime() : null;
  if (row.plan_status === 'trial' && trial)   return Math.ceil((trial - now) / 86400000);
  if (row.plan_status === 'grace' && grace)   return Math.ceil((grace - now) / 86400000);
  if (row.plan_status === 'expired' && grace) return -Math.floor((now - grace) / 86400000);
  return null;
}

// Relative time string for LAST SEEN: '2h ago', 'yesterday', '3 days ago', 'never'.
export function relativeTime(iso, now = Date.now()) {
  if (!iso) return 'never';
  const ms = now - new Date(iso).getTime();
  const min = Math.floor(ms / 60000);
  const h   = Math.floor(ms / 3600000);
  const d   = Math.floor(ms / 86400000);
  const w   = Math.floor(d / 7);
  if (min < 1)  return 'just now';
  if (h < 1)    return `${min}m ago`;
  if (d < 1)    return `${h}h ago`;
  if (d === 1)  return 'yesterday';
  if (d < 7)    return `${d} days ago`;
  if (w < 5)    return `${w} weeks ago`;
  return `${Math.floor(d / 30)} months ago`;
}

// Convert a yyyy-mm-dd "picked day" to a UTC ISO string representing 23:59:59
// in the property's local timezone (§3.3, §6).
export function localEodToUtc(pickedDay, country) {
  const tz = country === 'GR' ? 'Europe/Athens' : country === 'BG' ? 'Europe/Sofia' : 'UTC';
  // Build "yyyy-mm-ddT23:59:59" in tz then convert to UTC. JS lacks Intl tz arithmetic;
  // use the well-known trick: format the same instant in the target tz, compute offset.
  const localStr = `${pickedDay}T23:59:59`;
  const asIfUtc = new Date(`${localStr}Z`);
  const tzString = asIfUtc.toLocaleString('en-US', { timeZone: tz });
  const tzAsLocal = new Date(tzString);
  const offsetMs = asIfUtc.getTime() - tzAsLocal.getTime();
  return new Date(asIfUtc.getTime() + offsetMs).toISOString();
}

export function displayPlanSummary(row) {
  const fmt = (iso) => iso ? iso.slice(0, 10) : '—';
  switch (row.plan_status) {
    case 'trial':
      return `Trial ends ${fmt(row.trial_ends_at)} · grace until ${fmt(row.grace_ends_at)}`;
    case 'grace':
      return `Trial ended ${fmt(row.trial_ends_at)} · grace until ${fmt(row.grace_ends_at)}`;
    case 'expired':
      return `Expired since ${fmt(row.grace_ends_at)}`;
    case 'paid':
      return row.trial_started_at
        ? `Paid since ${fmt(row.trial_started_at)}`
        : 'Paid · grandfathered';
    case 'cancelled':
      if (row.trial_ends_at == null) {
        return row.trial_started_at
          ? `Cancelled · was paid since ${fmt(row.trial_started_at)}`
          : 'Cancelled · never paid';
      }
      return 'Cancelled · never paid';
    default:
      return '';
  }
}
